
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MergingItemsGrid extends Serenity.EntityGrid<MergingItemsRow, any> {
        protected getColumnsKey() { return 'Production.MergingItems'; }
        protected getDialogType() { return MergingItemsDialog; }
        protected getIdProperty() { return MergingItemsRow.idProperty; }
        protected getInsertPermission() { return MergingItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MergingItemsRow.localTextPrefix; }
        protected getService() { return MergingItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}